module.exports = __webpack_public_path__ + "img/Logo_DRU.6b0383e4.svg";